module.exports = __webpack_public_path__ + "static/media/undraw_programming_j1zw.6757f889.svg";